import { Component } from '@angular/core';
import { trigger, style, transition, animate } from '@angular/animations';

import { PromiseTrackerService } from './promise-tracker.service';

const inactiveStyle = style({
  opacity: 0
});
const timing = '.3s ease';

@Component({
  selector: 'div[bs-loading-backdrop]',
  template: `
        <div class="ng-busy-backdrop"
             @fadeInOut
             *ngIf="isActive()">
        </div>
    `,
  animations: [
    trigger('fadeInOut', [
      transition('void => *', [inactiveStyle, animate(timing)]),
      transition('* => void', [animate(timing, inactiveStyle)])
    ])
  ]
})
export class LoadingBackdropComponent {
  constructor(private tracker: PromiseTrackerService) {}

  isActive() {
    return this.tracker.isActive();
  }
}
